import React from 'react'

const PageNotFound = () => (
  <div>
    <span role="img" aria-label="Sad face">
      😢
    </span>
    Not Found
  </div>
)

export default PageNotFound



// WEBPACK FOOTER //
// ./src/routes/not-found/index.js